import { useEffect } from "react";
import { useStore } from "@/store/StoreContext";

export default function Seo({ title, description, image, canonical, noindex, schema }) {
  const { settings } = useStore();
  useEffect(() => {
    const seo = settings?.seo || {};
    const tpl = seo.title_template || "%s | TARISHQ FASHION";
    const finalTitle = title ? tpl.replace("%s", title) : (seo.default_title || "TARISHQ FASHION");
    document.title = finalTitle;
    const setMeta = (attr, key, content) => {
      if (!content) return;
      let el = document.head.querySelector(`meta[${attr}="${key}"]`);
      if (!el) { el = document.createElement("meta"); el.setAttribute(attr, key); document.head.appendChild(el); }
      el.setAttribute("content", content);
    };
    setMeta("name", "description", description || seo.default_description);
    setMeta("property", "og:title", finalTitle);
    setMeta("property", "og:description", description || seo.default_description);
    if (image || seo.default_og_image) setMeta("property", "og:image", image || seo.default_og_image);
    setMeta("property", "og:type", "website");
    setMeta("name", "robots", noindex ? "noindex, nofollow" : "index, follow");
    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) { link = document.createElement("link"); link.rel = "canonical"; document.head.appendChild(link); }
    link.href = canonical || window.location.href.split("?")[0];
    let schemaEl = document.getElementById("tq-jsonld");
    if (schemaEl) schemaEl.remove();
    if (schema) {
      schemaEl = document.createElement("script");
      schemaEl.type = "application/ld+json";
      schemaEl.id = "tq-jsonld";
      schemaEl.text = JSON.stringify(schema);
      document.head.appendChild(schemaEl);
    }
  }, [title, description, image, canonical, noindex, schema, settings]);
  return null;
}
